export const COLORS = {
primary:'#291C3A',
primary1:'#331C52',
secondry:'#8121D0',
gray:'#DCCFED',
white:'#FFFFFF',
gray1:'#E1EbED',
};